var React = require('react');

function SmallLineSecondPart (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M12.3,2.112C10.96,0.771,9.102,0,7.206,0S3.451,0.771,2.112,2.112C0.771,3.452,0,5.311,0,7.206\r\n\t\t\tS0.771,10.96,2.112,12.3c1.339,1.34,3.191,2.111,5.094,2.111c1.896,0,3.754-0.771,5.094-2.111c1.341-1.34,2.112-3.198,2.112-5.094\r\n\t\t\tS13.642,3.452,12.3,2.112z"}))));
}

SmallLineSecondPart.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"14.412px","height":"14.411px","viewBox":"0 0 14.412 14.411","enableBackground":"new 0 0 14.412 14.411","xmlSpace":"preserve"};

module.exports = SmallLineSecondPart;

SmallLineSecondPart.default = SmallLineSecondPart;
